import $ from 'jquery'

export const bp = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1440
}

export class Core {

  static isAdmin () {
    return $('body').hasClass('wp-admin') || $('body')[0].classList.length === 0;
  }

  static isProd () {
    const hostname = window.location.hostname.toLowerCase();
    const url = window.location.href.toLowerCase();

    // Check if we're in a local/development environment
    const devPatterns = [
      'local',
      'localhost',
      '127.0.0.1',
      '.test',
      '.dev',
      'staging',
      'preprod',
      '.mkt.',
    ];

    return !devPatterns.some(pattern => hostname.includes(pattern) || url.includes(pattern));
  }

  static getCurrentBp () {
    let window_width = $(window).width()

    if (window_width >= bp.xxl) {
      return 'xxl'
    } else if (window_width >= bp.xl) {
      return 'xl'
    } else if (window_width >= bp.lg) {
      return 'lg'
    } else if (window_width >= bp.md) {
      return 'md'
    } else if (window_width >= bp.sm) {
      return 'sm'
    } else {
      return 'xs'
    }
  }

  static scrollTo ($item, time) {
    if (! time) {
      time = 1000
    }

    // Use dynamic value or fallback to max value (admin bar + banner + header heights)
    const bodyTopOffset = window.getComputedStyle($('body')[0]).getPropertyValue('--body-top-offset');
    const offset = bodyTopOffset ? bodyTopOffset.replace('px', '') : 184;

    const scrollPos = $item.jquery ? $item.offset().top - offset : $item;

    window.scroller.scrollTo( scrollPos, {
      offset, // lenis ignore scroll-padding-top / scroll-margin-top so we pass it manually
      force: true,
      lock: true,
      duration: time / 1000,
      immediate: false,
    });
  }

  // Replace <img src="...*.svg"> with the inline SVG content fetched from the file
  // Preserves id, classes, data-* attributes and transfers alt to aria-label for accessibility
  static imgToSvg() {

    if ( Core.isAdmin() ) return;

    const imgs = document.querySelectorAll('img[src$=".svg"]');
    if (!imgs || !imgs.length) return;

    imgs.forEach((img) => {
      // Avoid processing already replaced images
      if (img.dataset.svgInline === 'true') return;

      const src = img.getAttribute('src') || img.src;
      if (!src) return;

      // Normalize the URL: if src is relative or from a different domain,
      // convert it to use the current site's origin for better compatibility
      let fetchUrl = src;
      try {
        const srcUrl = new URL(src, window.location.origin);
        const currentOrigin = window.location.origin;

        // If the src is from a different domain, try to use the current domain path
        if (srcUrl.origin !== currentOrigin) {
          // Extract the path and rebuild with current origin
          fetchUrl = new URL(srcUrl.pathname + srcUrl.search, currentOrigin).href;
          // console.log('🔄 Normalized SVG URL from', src, 'to', fetchUrl);
        } else {
          fetchUrl = srcUrl.href;
        }
      } catch {
        // URL parsing failed, use src as-is
        // console.warn('Could not parse SVG URL:', src, e);
      }

      // Fetch the SVG file
      fetch(fetchUrl, { cache: 'no-cache', mode: 'no-cors' })
        .then((res) => {
          if (!res.ok) throw new Error(`Failed to fetch SVG: ${res.status}`);
          return res.text();
        })
        .then((svgText) => {
          try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(svgText, 'image/svg+xml');
            const svgEl = doc.querySelector('svg');
            if (!svgEl) throw new Error('No <svg> found in fetched content');

            // Copy id if present
            if (img.id) svgEl.id = img.id;

            // Merge classes: keep svg classes + img classes
            const imgClasses = (img.getAttribute('class') || '').split(/\s+/).filter(Boolean);
            imgClasses.forEach((c) => svgEl.classList.add(c));

            // Transfer data-* attributes
            Array.from(img.attributes).forEach((attr) => {
              if (/^data-/i.test(attr.name)) {
                svgEl.setAttribute(attr.name, attr.value);
              }
            });

            // Transfer role/aria from img
            if (img.hasAttribute('alt') && !svgEl.hasAttribute('aria-label')) {
              const alt = img.getAttribute('alt');
              if (alt) svgEl.setAttribute('aria-label', alt);
            }

            // Ensure svg has xmlns attribute
            if (!svgEl.hasAttribute('xmlns')) svgEl.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

            // Preserve inline styles for width/height if set on the img
            const width = img.getAttribute('width');
            const height = img.getAttribute('height');
            if (width) svgEl.setAttribute('width', width);
            if (height) svgEl.setAttribute('height', height);

            // Mark to avoid re-processing
            svgEl.setAttribute('data-replaced-by', 'imgToSvg');

            // console.log('🔍', {svgEl}); // eslint-disable-line
            // console.log('🔍', {parentNode: img.parentNode}); // eslint-disable-line

            // Replace the img in the DOM with the svg element
            img.parentNode.replaceChild(svgEl, img);
          } catch {
            // parsing failed — keep original <img>
            // console.log('🔍', 'parsing failed — keep original <img>'); // eslint-disable-line

          }
        })
        .catch(() => {
          // fetch failed — ignore
          // console.log('🔍', 'fetch failed — ignore'); // eslint-disable-line

        });
    });
  }

  static isBpGreaterThan (bpTest) {
    if (bp.hasOwnProperty(bpTest)) {
      let window_width = $(window).width()

      if (window_width > bp[bpTest]) {
        return true
      }
    }

    return false
  }

  static isBpLessThan (bpTest) {
    if (bp.hasOwnProperty(bpTest)) {
      let window_width = $(window).width()

      if (window_width <= bp[bpTest]) {
        return true
      }
    }

    return false
  }

  static isAdminFront () {
    return $('body').hasClass('admin-bar')
  }

  static activeBodyScroll () {
    $('html, body').removeClass('disable-overflow')
  }

  static disableBodyScroll () {
    $('html, body').addClass('disable-overflow')
  }

}
